import { Button, Card, Col, Popover, Row, Typography } from "antd";
import { InfoCircleOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";


import SofwareForm from "./SoftwareForm";
import SofwareTable from "./SoftwareTable";
import { useEgresadoContext } from "./../../../context/EgresadoProvident";
import useSoftware from "./HookSoftware";
const { Title } = Typography;

const Software = ({ id_componente }) => {
    const { alumno } = useEgresadoContext();
    const {
        CatalogSoftware,
        CatalogUso,
        CatalogTipoDominio,
        loading,
        crearSoftware,
        editarSoftware,
        onCreateSoftware,
        onSave,
        onEdit,
        onDelete,
        onCancel
    } = useSoftware(alumno?.software);

    const isCreatingOrEditing = crearSoftware || Object.keys(editarSoftware).length > 0;

    return (
        <>
            <Card
                id={id_componente}
            >
                <Row justify="space-between" align="middle">
                    <Col>
                        <Popover
                            styles={{ root: { width: 250 } }}
                            title="Herramientas de software"
                            content={
                                <div style={{ textAlign: 'justify' }}>
                                    Agrega programas, plataformas o aplicaciones que sepas usar, como Excel, AutoCAD, Photoshop, entre otros.
                                </div>
                            }
                            placement="right" icon={<InfoCircleOutlined />}>

                            <Title level={5} strong>Herramientas de software <QuestionCircleOutlined /></Title>
                        </Popover>
                    </Col>
                    {
                        (!isCreatingOrEditing) &&
                        <Col>
                            <Button
                                loading={loading}
                                type="text"
                                style={{ color: '#7c0433' }}
                                icon={<PlusOutlined />}
                                onClick={() => onCreateSoftware()}
                            >
                                Agregar Software
                            </Button>
                        </Col>
                    }
                </Row>

                <Row >
                    {
                        (!isCreatingOrEditing) ?
                            <Col span={24}>
                                <SofwareTable
                                    loading={loading}
                                    catalog={CatalogSoftware}
                                    onEdit={onEdit}
                                    onDelete={onDelete}
                                />
                            </Col>
                            :
                            <Col span={24}>
                                <SofwareForm
                                    loading={loading}
                                    CatalogUso={CatalogUso}
                                    CatalogTipoDominio={CatalogTipoDominio}
                                    editarSoftware={editarSoftware}
                                    onSave={onSave}
                                    onCancel={onCancel}
                                />
                            </Col>
                    } </Row>
            </Card>

        </>
    );
}

export default Software;